/**
 * ENUM
 * Normaliza codigos de parceiros de pagamento.
 *
 * @author hjCostaBR
 */
export const PaymentPartnersEnum = {

    PAGSEGURO : {
        code: 1,
        name: "Pagseguro"
    },

    BCASH : {
        code: 2,
        name: "BCash"
    },

    PAYPAL : {
        code: 3,
        name: "Paypal"
    },

    CIELO : {
        code: 4,
        name: "Cielo"
    },

    IPAG : {
        code: 5,
        name: "Ipag"
    }
}



// WEBPACK FOOTER //
// ./src/enums/PaymentPartnersEnum.js